export default __webpack_public_path__ + "static/media/Insta.9c1fdbfb.svg";